// 设置闹钟——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `wifi/index${i + 1}`,
  name: `wifiIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/wifi/index${i + 1}.vue`)
}))



export default {
  path: '/phoneSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置闹钟——主流程，开始
    ...MainRoutes,

  ],
};
